angular.module('siter.io').factory 'User', ["Restangular", "$stateParams", "$rootScope", "$state", "$cookies", (Restangular, $stateParams, $rootScope, $state, $cookies) ->
  user =
    removeCollaborator: (collaborator) ->
      Restangular.all("sites").all($stateParams.siteId).all("collaborators").one(collaborator.id).customDELETE()
    me: ->
      Restangular.all("users").one("me.json").get()
    save: (user) ->
      Restangular.all("users").one(user.id).customPUT user
    forgotPassword: (email) ->
      Restangular.all("users").one("password").post email
  user
]



// WEBPACK FOOTER //
// ./src/app/profile/user.service.coffee